import React from 'react';
import '../template-file-css/document-file-template.css';



export const CBHS_PriorAuthorizationFormAethna = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='CBHS_PriorAuthorizationFormAethna' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'> <b>AETNA BETTER HEALTH® OF LOUISIANA</b> </p>
                <p className='w-750'> Prior authorization form </p>

                <p className='w-750'>
                    <b> Phone:</b>1-855-242-0802<br />
                    <b>Physical Health Fax:</b>1-844-227-9205<br />
                    <b>Behavioral Health Fax:</b>1-844-634-1109
                </p>

                <p className='w-750'>
                     Date of Request: &nbsp;
                    <input type='date' id='txtDateRequest' name='txtDateRequest' className='add-only w-250 custom-add-only' />
                </p>

                <p className='w-750'>
                    <b> For urgent requests (required within 24 hours), call Aetna Better Health of Louisiana at 1-855-242-0802 </b>
                </p>

                <p className='w-750'> <b> MEMBER INFORMATION </b> </p>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>ID Number</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtName" name="txtName" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtIdNumber" name="txtIdNumber" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date of Birth:</span></td>
                        <td className='w-375'><span className='eleHeader'>Physician Name:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtDateBirth" name="txtDateBirth" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtPhysicianName" name="txtPhysicianName" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Other Insurance:</span></td>
                        <td className='w-375'><span className='eleHeader'>Gender (circle one)</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtOtherInsurance" name="txtOtherInsurance" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="radio" id="rbGenderCircleOPne_Female" name="rbGenderCircleOne" className='add-only' value="Female" /> F &nbsp;
                            <input type="radio" id="rbGenderCircleOPne_Male" name="rbGenderCircleOne" className='add-only' value="Male" /> M
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b> REQUESTING PHYSICIAN OR PROVIDER INFORMATION</b> </p>

                <p className='w-750'><b>Referring Provider / Requesting Provider</b></p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Telephone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtName_1" name="txtName_1" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtTelephone_1" name="txtTelephone_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtAddress_1" name="txtAddress_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Fax #:</span></td>
                        <td className='w-375'><span className='eleHeader'>Specialty:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtFax_1" name="txtFax_1" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtSpecialty_1" name="txtSpecialty_1" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>National Provider Identification (NPI):</span></td>
                        <td className='w-375'><span className='eleHeader'>Contact Person:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtNpi_1" name="txtNpi_1" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtContactPerson_1" name="txtContactPerson_1" className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>Place of Service or Facility Name</b></p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Telephone #:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtName_2" name="txtName_2" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtTelephone_2" name="txtTelephone_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Address:</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtAddress_2" name="txtAddress_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Fax #:</span></td>
                        <td className='w-375'><span className='eleHeader'>Specialty:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtFax_2" name="txtFax_2" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtSpecialty_2" name="txtSpecialty_2" className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>National Provider Identification (NPI):</span></td>
                        <td className='w-375'><span className='eleHeader'>Contact Person:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" id="txtNpi_2" name="txtNpi_2" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtContactPerson_2" name="txtContactPerson_2" className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'> <b>REFERRAL / AUTHORIZATION INFORMATION</b> </p>

                <p className='w-750'> <span className='eleHeader'>Problem / Diagnosis (ICD-10 Code(s)):</span>
                    <textarea id='txtProblemDiagnosis_1' name='txtProblemDiagnosis_1' className='add-only'></textarea>
                </p>

                <p className='w-750'> <span className='eleHeader'>Procedure / Test Requested (CPT Code(s)):</span>
                    <textarea id='txtProcedure_1' name='txtProcedure_1' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date of Appointment or Service:</span></td>
                        <td className='w-375'><span className='eleHeader'>Number of Visits Required:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="date" id="txtDateAppointmentService" name="txtDateAppointmentService" className='add-only' /></td>
                        <td className='w-375'>
                            <input type="text" id="txtNumberVisitsRequired" name="txtNumberVisitsRequired" className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Type of Procedure : </span>
                    <span className='small'>(circle one): </span>

                    <input type="radio" id="rbProcedure_Inpatient" name="rbProcedure" className='add-only' value="inpatient" /> Inpatient &nbsp;
                    <input type="radio" id="rbProcedure_Outpatient" name="rbProcedure" className='add-only' value="outpatient" /> Outpatient &nbsp;
                    <input type="radio" id="rbProcedure_InOffice" name="rbProcedure" className='add-only' value="inoffice" /> In Office
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Other Clinical Information - Include clinical notes, lab and X-ray reports, etc. :</span>
                    <span className='small'>(For procedures, please attach additional pages as necessary.)</span>
                    <textarea id="txtOtherClinicalInformation" name="txtOtherClinicalInformation" className='add-only'></textarea>
                </p>

            </div>
        </form>

    )
} 